// JsFromRoutes CacheKey a3ed7aa017301cd5413fd666e13cd25e
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@consumer/services/api'

export default {
  create: /* #__PURE__ */ definePathHelper('post', '/add-friends/prompts'),
  sendTestEmail: /* #__PURE__ */ definePathHelper('post', '/add-friends/prompts/send_test_email'),
}
